export default {
  setTagsPersonalizzati(state, data) {
    state.tagPersonalizzati = data;
    var tmp = [];
    data.forEach((e) => tmp.push(e[0]));
    state.onlyTagsPersonalizzati = tmp;
    localStorage.setItem("onlyTagsPersonalizzati", JSON.stringify(tmp));
  },

  setTagsPersonalizzatiPreventivi(state, data) {
    state.tagPersonalizzatiPreventivi = data;
    var tmp = [];
    data.forEach((e) => tmp.push(e[0]));
    state.onlyTagsPersonalizzatiPreventivi = tmp;
    localStorage.setItem(
      "onlyTagsPersonalizzatiPreventivi",
      JSON.stringify(tmp)
    );
  },
};
